import React, { useState, useEffect } from "react";
import Loader from "../../utils/Loader";
import { EmeterData } from "../../Slices/ReportSlices";
import { useSelector, useDispatch } from "react-redux";




const EnergyMeterData = ({
  selectedEnterprise,
  selectedCountryState,
  selectedLocation,
  selectedGateway,
  pstartDate,
  pendDate,
  settingsComplete,
  selectedOptimizer
}) => {
  const dispatch = useDispatch();

  const { enterprises } = useSelector((state) => state.enterpriseDataSlice);
  const { emeterData_response } = useSelector((state) => state.reportSlice);

  const [emeterData, setEmeterData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const limit = 10;

  useEffect(() => {
    if (emeterData_response === undefined || emeterData_response === null) return;
    setLoading(false);
    if (emeterData_response?.data) {
      setEmeterData(emeterData_response.data);
      if (Array.isArray(emeterData_response.data) && emeterData_response.data.length > 0) {
        setHasNextPage(true);
      } else {
        // If no data on next page, revert to previous page and disable Next
        setHasNextPage(false);
        setPage((prev) => (prev > 1 ? prev - 1 : 1));
      }
    }
  }, [emeterData_response]);


  const selectedEnterpriseData = enterprises.find(
    (enterprise) => enterprise.entepriseId === selectedEnterprise
  );
  const countrystates = selectedEnterpriseData ? selectedEnterpriseData.states : [];
  const selectedCountryStateData = countrystates.find(
    (countrystate) => countrystate.stateId === selectedCountryState
  );
  const locations = selectedCountryStateData ? selectedCountryStateData.locations : [];
  const selectedLocationData = locations.find((location) => location.locId === selectedLocation);

  useEffect(() => {
    if (!selectedGateway || !pstartDate || !pendDate || !settingsComplete) return;
    setLoading(true);
    // Format dates as "M/D/YYYY hh:mm:ss A" to match backend expectation
    const formatDate = (dateStr) => {
      const dateObj = new Date(dateStr);
      const pad = (n) => n < 10 ? '0' + n : n;
      let month = dateObj.getMonth() + 1;
      let day = dateObj.getDate();
      let year = dateObj.getFullYear();
      let hours = dateObj.getHours();
      let minutes = pad(dateObj.getMinutes());
      let seconds = pad(dateObj.getSeconds());
      let ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      return `${month}/${day}/${year} ${pad(hours)}:${minutes}:${seconds} ${ampm}`;
    };

    const startDate = formatDate(pstartDate);
    const endDate = formatDate(pendDate);

    const header = {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
      },
    };

    const data = {
      startDate,
      endDate,
      Optimizerid: selectedOptimizer,
      page
    };

    dispatch(EmeterData({ data, header }));
  }, [selectedGateway, pstartDate, pendDate, settingsComplete, page]);

  const handlePrevClick = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNextClick = () => {
    if (hasNextPage) {
      setPage((prev) => prev + 1);
    }
  };


  return (
    <>
      <div className="px-2 py-4">
        {loading && <Loader />}
        {!loading && (
          <>
            {!settingsComplete && (
              <p className="text-gray-600 text-center">Please Fill the Fields to Get Emeter Data.</p>
            )}
            {emeterData.length === 0 && page === 1 && settingsComplete && (
              <p className="text-gray-600 text-center">No data available at the moment.</p>
            )}
            {emeterData.length > 0 && settingsComplete && (
              <>
                {/* Full-width responsive table */}
                <div
                  className="download_btn"
                  style={{ maxHeight: "800px", overflow: "auto", width: "100%" }}
                >
                  <table className="min-w-max w-full whitespace-no-wrap text-center">
                    <thead>
                      <tr className="text-xs font-semibold tracking-wide text-center text-gray-500 uppercase border-b bg-gray-50" style={{position: 'sticky', top: 0, zIndex: 2, background: '#F9FAFB'}}>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>GatewayID</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>OptimizerID</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>readableTime</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>RTV</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>CTV</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>RoomTemperature</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>Humidity</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>CoilTemperature</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>KWH</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>KVAH</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>PF</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>Current</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>Voltage</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>CompStatus</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>Ac_Status</th>
                        <th className="px-4 py-3" style={{position: 'sticky', top: 0, background: '#F9FAFB'}}>OptimizerMode</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y text-gray-800">
                      {emeterData.map((log) => (
                        <tr key={log._id} className="hover:bg-gray-100">
                          <td className="px-4 py-3">{log.GatewayID}</td>
                          <td className="px-4 py-3">{log.OptimizerID}</td>
                          <td className="px-4 py-3">{log.readableTime}</td>
                          <td className="px-4 py-3">{log.RTV}</td>
                          <td className="px-4 py-3">{log.CTV}</td>
                          <td className="px-4 py-3">{log.RoomTemperature}</td>
                          <td className="px-4 py-3">{log.Humidity}</td>
                          <td className="px-4 py-3">{log.CoilTemperature}</td>
                          <td className="px-4 py-3">{log.KWH}</td>
                          <td className="px-4 py-3">{log.KVAH}</td>
                          <td className="px-4 py-3">{log.PF}</td>
                          <td className="px-4 py-3">{log.Current}</td>
                          <td className="px-4 py-3">{log.Voltage}</td>
                          <td className="px-4 py-3">{log.CompStatus}</td>
                          <td className="px-4 py-3">{log.Ac_Status}</td>
                          <td className="px-4 py-3">{log.OptimizerMode}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* Pagination Section */}
                <div className="grid px-4 py-3 text-xs font-semibold tracking-wide text-gray-500 uppercase border-t bg-gray-50 sm:grid-cols-9">
                  {/* Page info - left */}
                  <span className="flex items-center col-span-3 text-base text-gray-700">
                    {`Page No. ${page}`}
                  </span>
                  <span className="col-span-2"></span>
                  {/* Prev/Next - right */}
                  <span className="flex col-span-4 mt-2 sm:mt-auto sm:justify-end">
                    <nav aria-label="Table navigation">
                      <ul className="inline-flex items-center">
                        <li>
                          <button
                            className={`py-2 px-3 mt-2 mr-3 focus:outline-none text-white rounded-lg ${page === 1
                              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                              : "bg-purple-600 hover:bg-purple-700"
                              }`}
                            aria-label="Previous"
                            onClick={handlePrevClick}
                            disabled={page === 1}
                            style={{
                              backgroundColor: page === 1 ? "#D1D5DB" : "",
                              color: page === 1 ? "#9CA3AF" : "",
                            }}
                          >
                            Prev
                          </button>
                        </li>
                        <li>
                          <button
                            className={`py-2 px-3 mt-2 focus:outline-none text-white rounded-lg ${!hasNextPage
                              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                              : "bg-purple-600 hover:bg-purple-700"
                              }`}
                            aria-label="Next"
                            onClick={handleNextClick}
                            disabled={!hasNextPage}
                            style={{
                              backgroundColor: !hasNextPage ? "#D1D5DB" : "",
                              color: !hasNextPage ? "#9CA3AF" : "",
                            }}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </span>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );


};

export default EnergyMeterData;
